/* ----- cart.js ----- */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {}

  disconnectedCallback() {}

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cartDrawerInner',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantityRender(parsedState, cartDrawerCallback) {
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'CartDrawer') {
        const parsedHtml = document.createElement('div');
        parsedHtml.innerHTML = parsedState.sections[section.section];

        const parsedUpdateEls = parsedHtml.querySelectorAll('[data-js-update]');
        if (parsedUpdateEls && parsedUpdateEls.length > 0) {
          parsedUpdateEls.forEach((el, index) => {
            const updateEl = document.querySelector(`[data-js-update="${el.dataset.jsUpdate}"]`);
            if (!updateEl) return;
            updateEl.innerHTML = el.innerHTML;
          });
        }

        document.dispatchEvent(new CustomEvent('cart-drawer-recs-reload'));

        if (typeof cartDrawerCallback === 'function') cartDrawerCallback();
      } else {
        const sectionEL = document.getElementById(section.id);
        if (!sectionEL) return;

        const elementToReplace = sectionEL.querySelector(section.selector) || sectionEL;
        if (!elementToReplace) return;

        const newDom = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );

        if (newDom) elementToReplace.innerHTML = newDom;
      }
    });
  }

  updateQuantity(line, quantity, name, variantId, cartDrawerCallback) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.updateQuantityRender(parsedState, cartDrawerCallback);

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';

        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        window.swipers();
      })
      .catch(error => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (!errors) return;
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      if (typeof message !== 'undefined' && message !== '') lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (!cartStatus) return;

    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (!(html || selector)) return;
    const $selector = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!$selector) return;
    return $selector.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems.classList.add('pointer-events');

    const cartItems = this.querySelectorAll(`#CartItem-${line}`);
    cartItems.forEach((item) => item.classList.add('loading'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems?.classList.remove('pointer-events');

    const cartItems = this.querySelectorAll(`#CartItem-${line}`);
    cartItems.forEach((item) => item.classList.remove('loading'));
    document.dispatchEvent(new CustomEvent('CartItemsOnChange'));
    document.dispatchEvent(new CustomEvent('cart-disable-loading'));
  }

  clear() {
    fetch(`${routes.cart_url}/clear.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then((response) => response.json())
    .then((cart) => {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'clear-button', cartData: cart });
    })
    .catch(error => {
      console.error('Error clearing cart:', error);
    });
  }
};

class DrawerItems extends CartItems {
  constructor() {
    super();
  }

  onCartUpdate() {
  }
}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/* ----- quantity-popover.js ----- */
if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.variantInfo = this.querySelector('.quantity-popover-container');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mql.matches) {
          this.popoverInfo.addEventListener('mouseenter', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonMobile.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.variantInfo.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.variantInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', !isExpanded);

        this.popoverInfo.toggleAttribute('hidden');

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        button.classList.toggle('quantity-popover__info-button--open');

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isChild = this.variantInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!event.relatedTarget || !isChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

/* ---- cart-drawer.js ----- */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('keyup', (evt) => evt.code === 'Escape' && document.documentElement.classList.contains('cart-drawer--active') && this.close());
    this.cartHiddenProductList = window.cartHiddenProductList || [];
    this.querySelector('#cartDrawerOverlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    if (window.location.hash === '#cart' || window.triggerCartOpen) {
      history.replaceState(null, null, ' ');
      this.open();
    }
  }

  setHeaderCartIconAccessibility() {
    if (window.location.pathname === '/cart') return;

    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    /* cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    }); */
  }

  open(triggeredBy) {
    document.dispatchEvent(new CustomEvent('cart-drawer-opened'));

    if (cartDrawerInner) cartDrawerInner.scroll(0, 0);

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    requestAnimationFrame(() => {
      window.inView();
      lockScrollEnable();
      document.documentElement.classList.add('cart-drawer--active');
      window.loadSwiper();
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        window.updateCartCount();
      },
      { once: true }
    );
  }

  close() {
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('cart-drawer--active');
    lockScrollDisable();
    window.updateCartCount();
    this.refreshCartCountBubble();
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart-drawer-closed'));
    }, 250);
  }

  clear() {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(cart => {
      const cartHeaderEl = document.querySelector('[data-js-update="cart-drawer-header"] strong');
      if (cartHeaderEl) {
        cartHeaderEl.textContent = 'Your cart is empty';
      }

      const drawerItemsEl = document.querySelector('drawer-items');
      if (drawerItemsEl) {
        drawerItemsEl.innerHTML = '';
      }

      this.classList.add('is-empty');

      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.add('is-empty');

      const drawerItems = document.querySelector('.drawer__items');
      const drawerEmpty = document.querySelector('.drawer__empty');

      if (drawerItems) drawerItems.classList.add('hide');
      if (drawerEmpty) drawerEmpty.classList.remove('hide');

      this.refreshCartCountBubble();
      return cart;
    })
    .catch(error => {
      console.error('Error clearing cart:', error);
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  refreshCartCountBubble() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // check for hidden items (Minimum Order Charge)
        const hiddenItems = cart.items.filter(item => this.cartHiddenProductList.includes(item.product_id));
        const cartItemCount = cart.item_count - hiddenItems.length;
        const cartCountBubble = document.querySelector('.cart-count-bubble');
        const cartTotalPrice = document.querySelector('#bulkOrderDrawer .view-cart__btn [data-cart-total]');

        if (cartItemCount < 1) {
          cartCountBubble.style.display = 'none';
          cartCountBubble.querySelector("[data-cart-icon-bubble-count]").innerHTML = 0;
        } else {
          cartCountBubble.style.display = 'flex';
          cartCountBubble.querySelector(".sr-only").innerHTML = `${cartItemCount} ${cartItemCount > 1 ? 'items' : 'item'}`;
          cartCountBubble.querySelector("[data-cart-icon-bubble-count]").innerHTML = cartItemCount;

          if (!cartTotalPrice) return;
          cartTotalPrice.dataset.cartTotal = cart.total_price;
          cartTotalPrice.innerHTML = `$${cart.total_price / 100}`;
        }
      });
  }

  renderContents(parsedState, openCartDrawer = true) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.querySelector(section.id);

      if (!sectionElement) return;

      if (section.id === 'cart-drawer') {
        const parsedHtml = document.createElement('div');
        parsedHtml.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        const parsedUpdateEls = parsedHtml.querySelectorAll('[data-js-update]');

        sectionElement.querySelectorAll('[data-js-update]').forEach((el, index) => {
          if (el) el.innerHTML = parsedUpdateEls[index] && parsedUpdateEls[index].innerHTML;
        });

        const parsedHideCartemptyEls = parsedHtml.querySelectorAll('.hide-cart-empty');
        sectionElement.querySelectorAll('.hide-cart-empty').forEach((el, index) => {
          parsedHideCartemptyEls[index] && el.classList[parsedHideCartemptyEls[index].classList.contains('hide') ? 'add' : 'remove']('hide');
        });

        document.dispatchEvent(new CustomEvent('cart-drawer-recs-reload'));
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    this.refreshCartCountBubble();

    if (!openCartDrawer) return;

    setTimeout(() => {
      this.querySelector('#cartDrawerOverlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#cartDrawerInner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

/*
 * The product an element belongs to, meaning its product-detail (the product page
 * or the Quick Add window), else its section. Variant, quantity and back-in-stock
 * lookups stay inside it, so the product page and a Quick Add never write into
 * each other (IWB-003).
 */
function getProductRoot(el) {
  return el.closest('product-detail') || el.closest('.shopify-section') || document;
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.aftershipHidden = false;
    this.limitedUpdate = this.hasAttribute('data-limited-update') && this.dataset.limitedUpdate === 'true';
  }

  quantityUpdateUnsubscriber = undefined;

  getRoot() {
    return getProductRoot(this);
  }

  connectedCallback() {
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      (event) => {
        // An event without a root (an app or a future publisher) still works as before.
        if (event.root && event.root !== this.getRoot()) return;
        this.inputQuantity = event.quantity;
        const btnText = this.getButtonText();
        const disableBtn = this.currentVariant ? !this.currentVariant.available : true;
        this.toggleAddButton(disableBtn, btnText, false);
      }
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  async onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.limitedUpdate) {
      this.toggleAddButton(true, '', false);
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateOptionsLegend();
      this.updateVariantInput();
      await this.renderProductInfo();
      this.updateUOM();

      if (!this.limitedUpdate) {
        this.updateSku();
        this.updateURL();
      } else {
        this.updateSetInputs();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionsLegend() {
    this.currentVariant.options.forEach((option, index) => {
      const replaceText =
        this.getOptionValueReplaceText() &&
        this.getOptionValueReplaceText().find((o) => option === o.title);
      const el = this.querySelector(`[data-product-option-value-active="${index}"]`);
      el ? (el.innerText = replaceText ? replaceText.replace : option) : null;
    });
  }

  getUOM() {
    const uomEl = this.querySelector('[type="application/json"][data-json="uom"]');
    if (uomEl) return JSON.parse(uomEl.textContent);
    return window.uom || null;
  }

  updateUOM() {
    const uom = this.getUOM();
    if (!uom) return;
    const el = this.querySelector('[data-product-option-uom]');
    const option = this.currentVariant[`option${uom.option_index}`];

    if (!el) return;
    el.innerHTML = '';

    if (option) {
      let uomValue = '';
      const optionLookup = `(${option})`;
      const uomDescription = uom.uom_explanations?.find((x) => x.includes(optionLookup));

      if (uomDescription) {
        uomValue = uomDescription;
      }

      el.innerHTML = uomValue;

      window.publish(PUB_SUB_EVENTS.uomChange, {
        sectionId: this.dataset.section,
        uom: option,
      });
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    window.publish(PUB_SUB_EVENTS.variantChange, {
      sectionId: this.dataset.section,
      currentVariant: this.currentVariant,
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = this.getRoot().querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;

    // A Quick Add never touches the address bar. Its "View Full Details" link
    // carries the chosen variant instead.
    if (this.closest('quickadd-modal')) {
      const link = this.getRoot().querySelector('.quickadd__view-pdp-cta');
      if (!link) return;
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', this.currentVariant.id);
      link.href = url.toString();
      return;
    }

    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateBadge(html) {
    const elId = `badge-${this.dataset.section}`;
    const el = this.getRoot().querySelector(`#${elId}`);
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const parsedEl = parsedHtml.querySelector(`#${elId}`);
    if (!(el && parsedEl)) return;
    el.innerHTML = parsedEl.innerHTML;
  }

  updateSku() {
    const skuEl = this.getRoot().querySelector('#productSku');
    if (!(this.currentVariant && skuEl)) return;
    skuEl.innerText = this.currentVariant.baseSku;
  }

  updateVariantInput() {
    const productForms = this.getRoot().querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = this.getRoot().querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  getButtonText() {
    if (!this.currentVariant) {
      this.updateOptions();
      this.updateMasterId();
    }

    if (this.currentVariant.available) {
      if (this.currentVariant.preorder) {
        return window.variantStrings.preorder || 'Pre-Order';
      } else if (this.currentVariant.backordered) {
        return window.variantStrings.backordered || 'Backorder';
      } else if (this.currentVariant.qty < this.inputQuantity) {
        return window.variantStrings.partialBackordered || 'Partial Backorder';
      } else {
        return window.variantStrings.addToCart || 'Add To Cart';
      }
    } else {
      return window.variantStrings.soldOut || 'Sold out';
    }
  }

  async renderProductInfo() {
    const sectionId = this.dataset.section;
    await fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        this.updateBadge(responseText);

        const classNames = [
          ".pdp__accordion-content--description",
          ".pdp__accordion-content--description-features",
          ".pdp__accordion-content--logistical-details",
          ".pdp__accordion-content--product-specifications",
          ".pdp__accordion-content--downloads",
          ".pdp__accordion-content--warning",
          ".pdp__title-primary",
          ".pdp__title-secondary",
          ".pdp__title-h2",
          '[data-json="uom"]'
        ];
        const id = `price-${sectionId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const root = this.getRoot();
        // price-<section> appears twice per render, and the first match is the outer one.
        const destination = root.querySelector(`#price-${this.dataset.section}`);
        const source = html.getElementById(id);

        classNames.forEach((className) => {
          const accordionContent = root.querySelectorAll(className);
          const newAccordionContent = html.querySelector(className);
          if (newAccordionContent?.innerHTML) {
            accordionContent.forEach((content) => {
              content.innerHTML = newAccordionContent.innerHTML;
            });
          }
        });

        if (source && destination) destination.innerHTML = source.innerHTML;

        root
          .querySelector(`#price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden');

        const btnText = this.getButtonText();
        this.toggleAddButton(!this.currentVariant.available, btnText);

        const propertiesId = 'variant-properties';
        const propertiesDestination = root.querySelector(`#${propertiesId}`);
        const propertiesSource = html.getElementById(propertiesId);

        if (propertiesSource && propertiesDestination)
          propertiesDestination.innerHTML = propertiesSource.innerHTML;

        const poId = 'PurchaseOrders';
        const poDestination = root.querySelector(`#${poId}`);
        const poSource = html.getElementById(poId);

        if (poSource && poDestination)
          poDestination.innerHTML = poSource.innerHTML;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = this.getRoot()
      .querySelector(`#product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;
    if (text) {
      addButton.textContent = text;
      addButton.dataset.label = text;
    }

    if (disable) {
      addButton.setAttribute('disabled', true);
    } else {
      addButton.removeAttribute('disabled');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const root = this.getRoot();
    const addButton = root
      .querySelector(`#product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    root.querySelector(`#price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][data-json="product-variants"]').textContent);
    return this.variantData;
  }

  getOptionValueReplaceText() {
    this.optionNameReplaceText = this.optionNameReplaceText || JSON.parse(this.querySelector('[type="application/json"][data-json="option-value-replace-text"]').textContent);
    return this.optionNameReplaceText;
  }

  updateSetInputs() {
    this.querySelectorAll(':checked').forEach((input) => {
      const setInput = this.getRoot().querySelector(`input[data-form-id="${input.getAttribute('form')}"][name$="id"]`);
      if (setInput) setInput.value = this.currentVariant.id;
    });
  }
};

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      return inputs.length === 1 ? inputs[0].value : inputs.length && inputs.find((radio) => radio.checked)?.value;
    });
  }
};

customElements.define('variant-radios', VariantRadios);

/* ----- globals ----- */
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function lockScrollEnable() {
  window.pageY = window.scrollY;
  document.body.style.left = 0;
  document.body.style.right = 'var(--scrollbar-width)';
  document.body.style.top = `-${window.pageY}px`;
  document.body.style.position = 'fixed';
}

function lockScrollDisable() {
  document.body.style.position = null;
  document.body.style.left = null;
  document.body.style.right = null;
  document.body.style.top = null;
  window.scrollTo(0, window.pageY);
}

function loadMinicart() {
  if (window.minicartLoaded) return;

  fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
    .then(response => response.json())
    .then(data => {
      if (window.minicartLoaded) return;
      document.querySelector('#cartDrawerInner').innerHTML = (new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('#cartDrawerInner').innerHTML)
      window.loadSwiper();
      window.minicartLoaded = true;
    })
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; /* If not TAB key */
    /* On the last focusable element and tab forward, focus the first element. */
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    /*  On the first focusable element and tab backward, focus the last element. */
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/* Currency formatter */
window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || window.theme?.moneyFormat || '${{amount}}');
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const isBulkOrderForm = evt.target.getAttribute('data-type') === 'bulk-order-add-to-cart-form';
        const openCartDrawer = !isBulkOrderForm;
        const btnDisabled = this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true';

        if (btnDisabled) return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const isQuickadd = evt.target.getAttribute('id').includes('-quickadd');

        if (isQuickadd) {
          const quickaddQuantity = evt.target.parentElement.querySelector('#Quantity-product-quickadd').value;
          formData.set('quantity', quickaddQuantity);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton && this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              fetch(`${routes.cart_url}.js`)
                .then(response => response.json())
                .then(data => {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form-cart-total',
                    cartData: data,
                  });
                });
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            const quickaddModal = this.closest('[data-quickadd-dialog]');
            if (quickaddModal) quickaddModal.close();

            this.cart.renderContents(response, openCartDrawer);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            this.closest('.quickadd--loading')?.classList.remove('quickadd--loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
      if (event.root && event.root !== getProductRoot(this)) return;
      this.validateQtyRules();
    });
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    publish(PUB_SUB_EVENTS.quantityUpdate, {
      source: 'product-form',
      quantity: parseInt(this.input.value),
      root: getProductRoot(this),
    });
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      if (!this.dataset.url) {
        this.closest('.shopify-section')?.classList.add('hide');
        return;
      } else {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');

              html.innerHTML = text;

              const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
              const recommendations = parsedHTML.querySelector('product-recommendations');
              const hasRecs = parsedHTML.querySelector('.product-card:not([hidden])') !== null;
              const hasFallbacks = parsedHTML.querySelectorAll('.product-card[hidden]');
              const hasProducts = hasRecs || hasFallbacks.length > 0;

              if (recommendations && recommendations.innerHTML.trim().length) {
                if (hasProducts) {
                  if (!hasRecs && hasFallbacks) {
                    hasFallbacks.forEach(el => el.removeAttribute('hidden'));
                  }

                  this.innerHTML = recommendations.innerHTML;

                  requestAnimationFrame(() => {
                    window.loadSwiper();
                    this.classList.add('recs--loaded');
                  });
                } else {
                  this.closest('.shopify-section').classList.add('hide');
                }
              }
            })
            .catch(e => {
              console.error(e);
            })
        };

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('product-recommendations')) {
      customElements.define('product-recommendations', ProductRecommendations);
    }
  });
}

(() => {
  const onScroll = () => {
    if (window.menuToggling) return;


    if (window.pageYOffset > window.headerScrolledThreshold) {
      document.documentElement.classList.add('header--scrolled');
    } else {
      document.documentElement.classList.remove('header--scrolled');
    }

    if (window.pageYOffset > 80 + window.headerScrolledThreshold) {
      document.documentElement.classList.add('header--scrolled--after');
    } else {
      document.documentElement.classList.remove('header--scrolled--after');
    }

    const scrollTop = window.pageYOffset;

    /* scroll direction */
    window.scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
    document.documentElement.dataset.scrollDirection = window.scrollDirection;
    lastScrollTop = window.pageYOffset;
  };

  const inViewVideo = (el, src) => {
    const $video = el.closest('video');

    if (!$video) return;
    if (typeof src !== 'undefined') $video.src = el.dataset.inViewVideoSrc;

    if (!$video.hasAttribute('data-autoplay')) return;
    /* $video.removeAttribute('controls'); */
    $video.play();
  };

  window.lazyLoadScript = obj => {
    const isLoaded = document.head.querySelector(`script[src='${obj.src}']`);
    const cb = obj.callback && typeof window[obj.callback] === 'function' ? window[obj.callback] : null;

    if (isLoaded || !obj.hasOwnProperty('src')) {
      if (cb) cb();
      return;
    }

    const $script = document.createElement('script');
    $script.dataset.inViewScriptName = obj.src;
    $script.type = obj.type || 'text/javascript';
    if (obj.defer) $script.defer = true;
    else if (obj.async) $script.async = true;
    $script.src = obj.src;
    document.head.appendChild($script);

    if (cb) $script.onload = requestAnimationFrame(() => {
      cb()
    });
  }

  const inViewScript = obj => {
    lazyLoadScript(obj);
  };

  /* root (optional) limits the work to one element, e.g. the Quick Add window */
  window.loadSwiper = (root = document) => {
    /* load swiper if needed */
    if (!window.swiperLoaded && typeof Swiper !== 'function') {
      const $script = document.createElement('script');
      $script.async = true;
      $script.src = window.assetUrls['swiper.js'];
      document.head.appendChild($script);
      window.swiperLoaded = true
    }

    const swiperIsReady = new Promise(resolve => {
      let timer = setInterval(() => {
        if (typeof Swiper === 'function') {
          clearInterval(timer);
          return resolve();
        }
      }, 30)
    });

    swiperIsReady.then(() => {
      window.swipers(root);
    }).catch(error => {
      /* console.log('Something went wrong', error); */
    })
  };

  /* swipers init via data-swiper={options} */
  window.swiperEls = [];
  window.swipers = (root = document) => {
    root.querySelectorAll('[data-swiper]:not(.swiper-initialized)').forEach((el, index) => {
      window.swiperEls[index] = new Swiper(el, Object.assign({}, {
        a11y: true,
        observer: true,
        slidesPerView: 'auto',
        threshold: 8,
      }, JSON.parse(el.dataset.swiper)));

      const changeEvent = el.getAttribute('data-swiper-slide-change');

      if (changeEvent && window.hasOwnProperty(changeEvent) && typeof window[changeEvent] === 'function') {
        window.swiperEls[index].on('slideChange', function(e) {
          window[changeEvent](e);
        })
      }
    });
  };

  window.inView = (root = document) => {
    /* add .in-view class to [data-in-view] els as they enter the viewport */
    const inViewEls = root.querySelectorAll('[data-in-view]');

    const inViewObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');

          if (entry.target.hasAttribute('data-autoplay') || entry.target.hasAttribute('data-in-view-video-src')) {
            inViewVideo(entry.target, entry.target.dataset.inViewVideoSrc);
          }

          if (entry.target.hasAttribute('data-in-view-swiper')) {
            loadSwiper();

            inViewObserver.unobserve(entry.target);
          }

          if (entry.target.hasAttribute('data-in-view-script')) {
            inViewScript(JSON.parse(entry.target.dataset.inViewScript));
          }
        } else {
          if (entry.target.hasAttribute('data-autoplay') && entry.target.paused == false) {
            entry.target.pause()
          }
        }
      });
    });

    inViewEls.forEach(el => inViewObserver.observe(el));
  };

  window.cartRemoveItem = index1 => {
    const cartItems = document.querySelector('drawer-items') || document.querySelector('cart-items');

    const removeCartLineItemInit = () => {
      requestAnimationFrame(() => {
        cartItems.updateQuantity(index1, 0, null, null, () => {
          window.updateCartCount();
          document.querySelector('cart-drawer').refreshCartCountBubble();
        });
      });
    }

    if (window.cartReady) {
      removeCartLineItemInit();
    } else {
      document.addEventListener('cart-ready', () => {
        removeCartLineItemInit();
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('cart-remove-button')) {
      customElements.define('cart-remove-button', CartRemoveButton);
    }

    if (!customElements.get('cart-items')) {
      customElements.define('cart-items', CartItems);
    }

    if (!customElements.get('drawer-items')) {
      customElements.define('drawer-items', DrawerItems);
    }

    if (!customElements.get('cart-drawer')) {
      customElements.define('cart-drawer', CartDrawer);
    }

    window.lastScrollTop = window.pageYOffset;

    onScroll();
    inView();

    window.addEventListener('scroll', () => {
      onScroll();
    }, { passive: true });

    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('cart-ready'));
      window.cartReady = true;
    });
  });

  let resizeTimer = null;
  let winWidth = null;
  window.addEventListener('resize', e => {
    clearTimeout(resizeTimer);
    if (!winWidth) winWidth = window.innerWidth;
    resizeTimer = setTimeout(() => {
      if (window.innerWidth !== winWidth) document.dispatchEvent(new CustomEvent('onResizeEnd'));
      winWidth = null;
    }, 250);
  });

  window.addEventListener('keyup', e => {
    if (e.key === 'Escape') document.dispatchEvent(new CustomEvent('onEsc'));
  });

  window.addEventListener('load', e => {
    if (window.cartLinesToRemove && cartLinesToRemove.length > 0) cartLinesToRemove.forEach((item, index) => {
      window.cartRemoveItem(parseFloat(item));
      window.cartLinesToRemove.splice(index, 1);
    });
  });

  window.updateCartCount = (delay = 300) => {
    requestAnimationFrame(() => {
      const $count = document.querySelector('[data-cart-icon-bubble-count]');
      const count = $count ? $count.innerText : 1
      /* wait for cart-drawer transition to finish then update data-cart-count which is used to adjust the padding next to cart icon in header*/
      setTimeout(() => {
        document.documentElement.dataset.cartCount = count
      }, delay);
    });
  }

  document.addEventListener('CartItemsOnChange', () => {
    window.updateCartCount();
  })

  window.getCookie = (name) => {
    let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? decodeURIComponent(v[2]) : null;
  }

  // Set days to '' for session cookies
  window.setCookie = (name, value, days) => {
    let d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    d = days != '' ? d.toGMTString() : ''
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + ";path=/;expires=" + d;
  }

  window.deleteCookie = (name) => {
    setCookie(encodeURIComponent(name), '', -1);
  }

  document.addEventListener('click', (e) => {
		if (e.target.matches('[data-toggle-class]')) {
      e.preventDefault();
      const el = e.target;
      const className = el.getAttribute('data-toggle-class');
      const target = el.hasAttribute('data-toggle-class-on') ? document.querySelector(el.getAttribute('data-toggle-class-on')) : document.documentElement;
      target.classList.toggle(className);
		}
	});

  // Cart Drawer Upsell
  document.addEventListener('change', e => {
    if (e.target.matches('[form="cart-drawer-upsell"]')) {
      const select = e.target;
      const container = select.closest('[data-cart-drawer-upsell-item]');
      const data = JSON.parse(container.querySelector('[data-json="cart-drawer-upsell-variants"]').innerHTML);
      const options = Array.from(container.querySelectorAll('select'), (select) => select.value);
      const index = data.findIndex((item) => item.options.toString() == options.toString());
      const variant = index >= 0 ? data[index] : null;
      const input = container.querySelector('input[name="id"]');
      const submit = container.querySelector('[data-cart-draweer-upsell-add-to-cart]');
      const price = container.querySelector('[data-cart-draweer-upsell-price]');
      const priceOriginal = price.getAttribute('data-cart-draweer-upsell-price');
      const sku = container.querySelector('[data-cart-draweer-upsell-sku]');
      const skuOriginal = sku.getAttribute('data-cart-draweer-upsell-sku');

      if (variant) {
        input.value = variant.id;
        if (variant.available) {
          submit.disabled = false;
          submit.textContent = variant.backordered ? window.variantStrings.backordered : window.variantStrings.addToCart;
        } else {
          submit.disabled = true;
          submit.textContent = window.variantStrings.soldOut;
        }
        price.textContent = window.Shopify.formatMoney(variant.price).replace('.00', '');
        sku.textContent = variant.sku;
      } else {
        submit.disabled = true;
        submit.textContent = window.variantStrings.addToCart;
        price.textContent = window.Shopify.formatMoney(priceOriginal).replace('.00', '');
        sku.textContent = skuOriginal;
      }
    }
  });

  window.cartDrawerUpsellSubmit = (e) => {
    const data = new FormData(e.target);
    const body = JSON.stringify(Object.fromEntries(data.entries()));

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        loadMinicart();
        const bubble = document.querySelector('[data-cart-icon-bubble-count]');
        const bubbleCount = Number(bubble.innerText);
        if (typeof bubbleCount === 'number') {
          bubble.textContent = bubbleCount + 1;
        }
      })
      .catch(error => {
        document.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (!errors) return;
        errors.textContent = window.cartStrings.error;
      });
  };

  /* Lazy Load Yotpo for reviews widgets (quickadd + pdp) */
  window.productReviewsLoadedCallback = () => {};
  window.productReviews = () => {
    window.lazyLoadScript({
      callback: 'productReviewsLoadedCallback',
      src: `https://cdn-widgetsrepository.yotpo.com/v1/loader/${ window.yotpoAppKey }?languageCode=${ window.isoCode }`
    });
  };

  localStorage.setItem('klv_sort_productList', 'RELEVANCE');
})();
